import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EBulletinFormPage from "./EBulletinFormPage"
import EBulletin from "models/EBulletinModel";

const EBulletinEdit = () => {
  const [eBulletinData, setEBulletinData] = useState({})

  const params = useParams();

  const getEBulletinData = async (id) => {
    return await EBulletin.getById(id);
  }

  useEffect(() => {
    (async () => {
      const result = await getEBulletinData(params.id)
      setEBulletinData(result)
    })()
  }, [params])


  return (
    <EBulletinFormPage eBulletinData={eBulletinData}></EBulletinFormPage>
  )
}

export default EBulletinEdit;
